/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const facilityInfrastructureEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    ShortCircuit: 'ShortCircuit',
    BreakerTrip: 'BreakerTrip',
    Other: 'Other',
} as const;

export type FacilityInfrastructureEnumsFaultTypeOptionEnumKey =
    (typeof facilityInfrastructureEnumsFaultTypeOptionEnum)[keyof typeof facilityInfrastructureEnumsFaultTypeOptionEnum];

export type FacilityInfrastructureEnumsFaultTypeOption = FacilityInfrastructureEnumsFaultTypeOptionEnumKey;
